import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { useIntl } from 'react-intl';
import { CmdToastButton } from '@commander-services/gui-components/build/components/CmdToast';
import * as VehiclesDataState from '../../store/recoil/vehiclesData';
import { IVehicleData } from '../Vehicles/types';
import ConfirmToaster from '../Forms/ConfirmToaster/ConfirmToaster';
import usePrevious from '../../hooks/usePrevious';

interface IProps {
  loadData: () => void;
  vehicleId: number;
  isNotFilterableByRide?: boolean;
}

export default function RideJustStarted(props: IProps) {
  const { formatMessage: f } = useIntl();

  const vehicleData = useRecoilValue<IVehicleData | null>(
    VehiclesDataState.vehicleDataByIdSelector(props.vehicleId)
  );
  const [isRideJustStarted, setIsRideJustStarted] = React.useState(false);
  const previousVehicleStatus = usePrevious(vehicleData?.status, { jsonParse: false });

  React.useEffect(() => {
    if (
      vehicleData?.status &&
      previousVehicleStatus &&
      vehicleData?.status !== previousVehicleStatus
    ) {
      if (vehicleData?.status === 'DRIVING' && previousVehicleStatus === 'STOP') {
        setIsRideJustStarted(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleData?.status, previousVehicleStatus]);

  const handleConfirmCancel = () => {
    setIsRideJustStarted(false);
  };

  const handleSubmitToastr = () => {
    setIsRideJustStarted(false);
    props.loadData();
  };

  const buttons: CmdToastButton[] = [
    {
      title: f({
        id: 'waypoint.confirm.dialog.cancel',
      }),
      style: 'link',
      type: 'cancel',
      onClickCallback: handleConfirmCancel,
    },
    {
      title: f({
        id: props.isNotFilterableByRide
          ? 'graph.toastr.newData.button.submit'
          : 'graph.velocity.toastr.newRide.button.submit',
      }),
      style: 'solid',
      type: 'submit',
      onClickCallback: handleSubmitToastr,
    },
  ];

  return isRideJustStarted ? (
    <ConfirmToaster
      id="toast"
      title={f({
        id: 'toastr.info',
      })}
      message={f({
        id: props.isNotFilterableByRide
          ? 'graph.toastr.newData.message'
          : 'graph.velocity.toastr.newRide.message',
      })}
      type="info"
      duration={null}
      onClose={handleConfirmCancel}
      buttons={buttons}
    />
  ) : null;
}
